import useBreadcrumbs from '@admin/hooks/useAdminBreadcrumbs';
import PageHeader from '@shared/components/core/headers/PageHeader';
import NotificationListing from '@shared/components/notification/NotificationListing';
import { useNotificationStore } from '@shared/hooks/state/NotificationContainer';
import { useTranslation } from 'react-i18next';

export default function NotificationPage() {
    const { t } = useTranslation();
    const { items } = useBreadcrumbs();
    const notifications = useNotificationStore((state) => state.notifications);

    return (
        <>
            <PageHeader title={t('common:notifications.center')} items={items} />
            <NotificationListing notifications={notifications} />
        </>
    );
}
